import { render, staticRenderFns } from "./CustomerYtdGrossProfitNumberDisplayer.vue?vue&type=template&id=3099ed15"
import script from "./CustomerYtdGrossProfitNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./CustomerYtdGrossProfitNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports